import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { SchoolScheduleType } from "../../../types/SchoolSchedule";
import { get, post, put } from "../../../utils/axios-config";
import { SCHOOLS_SCHEDULES, SCHOOLS_SCHEDULES_STUDENT } from "../../../utils/constants";


export const createSchoolSchedule= async (data: SchoolScheduleType) => await post<SchoolScheduleType, string>(SCHOOLS_SCHEDULES, data);
export const updateSchoolSchedule= async (data: SchoolScheduleType) => await put<SchoolScheduleType, string>(SCHOOLS_SCHEDULES, data);
export const getSchoolSchedule= async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
    });
    const url = `${SCHOOLS_SCHEDULES}?${queryParams.toString()}`;
    return await get<PagedResultsType<SchoolScheduleType>>(url)
};
export const getStudentSchoolSchedule= async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
    });
    const url = `${SCHOOLS_SCHEDULES_STUDENT}?${queryParams.toString()}`;
    return await get<PagedResultsType<SchoolScheduleType>>(url)
};